module.exports = __webpack_public_path__ + "static/media/adornmentCards.0d9eb9a4.svg";